import Translatable from "@/components/translatable_text/Translatable";

function ConsultationCTA() {
  return (
    <section className="py-20 wow d-rotate">
      <div className="container mx-auto px-6 rotate-text">
        <div className="max-w-4xl mx-auto border border-gray-200 rounded-lg p-10 md:p-14 bg-white d-rotate wow">
          <div className="text-center">
            <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-4">
              <Translatable>Build with clarity. Deliver with confidence.</Translatable>
            </h2>

            <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-8 max-w-2xl mx-auto">
              <Translatable>
              Partner with GCAD as your integrated technical consultant.
              Through the TPPM protocol, we guide your project from intake
              to delivery — ensuring smarter technical decisions and
              successful execution.
              </Translatable>
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/consultaion-requests"
                className="inline-flex items-center justify-center px-8 py-3 rounded-xl text-white bg-gray-900 hover:bg-gray-200 transition-colors duration-200"
              >
                <Translatable>Start Your Consultation</Translatable>
              </a>

              <a
                href="/services/development-encryption"
                className="inline-flex items-center justify-center px-8 py-3 rounded-xl text-gray-900 border border-gray-300 hover:border-gray-900 transition-colors duration-200"
              >
                <Translatable>Explore Our Protocol</Translatable>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    
  );
}

export default ConsultationCTA;
